import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Liability } from '../../models/liability.model';

@Component({
standalone: false,
  selector: 'app-fill-description-dialog',
  styleUrls: ['./fill-description-dialog.component.scss'],
  templateUrl: './fill-description-dialog.component.html',
})
export class FillDescriptionDialogComponent implements OnInit {
  public descriptionMaxLength = 90;
  public description = new FormControl(null, [Validators.maxLength(this.descriptionMaxLength)]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public liability: Liability,
    private dialogRef: MatDialogRef<FillDescriptionDialogComponent>,
  ) {}

  public ngOnInit(): void {
    this.description.setValue(this.liability.description);
  }

  public save(): void {
    this.dialogRef.close({ description: this.description.value });
  }
}
